const webview_actions = {

}

export default webview_actions